export default __webpack_public_path__ + "static/know-how-086149fe7177e51f14e9abc4d37d33ac.svg";